<div *ngIf="input?.invalid && (input?.dirty || input?.touched)"
    class="container-alert alert" [ngClass]="alertCss">
    <i class="fa-solid fa-triangle-exclamation me-1 mt-1"></i>

    <div *ngIf="input?.errors?.['required']">
        {{name}} es obligatorio
    </div>
    <div *ngIf="input?.errors?.['minlength']">
       Debe ingresar un minimo de <b>{{input?.errors?.['minlength'].requiredLength}} </b> caracteres.
    </div>
    <div *ngIf="input?.errors?.['email']">
        El correo ingresado no es valido
    </div>
    <div class="" *ngIf="input?.errors?.['invalidRut']">
        &nbsp; El RUT ingresado no es valido
    </div>
    <div *ngIf="input?.errors?.['maxlength']">
        {{name}} admite como máximo <b>{{input?.errors?.['maxlength'].requiredLength}}</b> caracteres.
    </div>
    <div *ngIf="input?.errors?.['blank']">
        {{name}} no puede estar en blanco
    </div>
    <div *ngIf="input?.errors?.['invalidPhone']">
        El teléfono no es válido (use entre 8 y 15 dígitos, por ejemplo +56 9 1234 5678)
    </div>
    <div *ngIf="input?.errors?.['passwordSpaces']">
        La contraseña no puede comenzar ni terminar con espacios
    </div>
    <div *ngIf="input?.errors?.['duplicate']">
        {{name}} ya se encuentra registrado
    </div>
    <div *ngIf="input?.errors?.['server']">
        {{ input?.errors?.['server'] }}
    </div>
    <div class="" *ngIf="input?.errors?.['pattern']">
        &nbsp; {{name}} no cumple con el formato requerido
    </div>
</div>